var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import { ErrorMessage as HookErrorMessage } from "@hookform/error-message";
// Say Lib
import Text from "../Text";
var ErrorIconElement = (_jsx(ErrorIcon, { fontSize: "small", color: "error", style: { fontSize: "16px" } }));
/**
 * Error message display for hook inputs
 */
var ErrorMessage = function (_a) {
    var errors = _a.errors, name = _a.name, _b = _a.sx, sx = _b === void 0 ? {} : _b;
    return (_jsx(HookErrorMessage, { errors: errors, name: name, render: function (_a) {
            var messages = _a.messages, message = _a.message;
            if (messages) {
                return (_jsx(Box, __assign({ sx: __assign({ mt: 3 }, sx) }, { children: Object.entries(messages).map(function (_a) {
                        var _b = __read(_a, 2), type = _b[0], message = _b[1];
                        return (_jsxs(Stack, __assign({ direction: "row", gap: 1, alignItems: "center" }, { children: [ErrorIconElement, _jsx(Text, __assign({ "data-testid": "multi-error", category: "error", shade: "dark", emphasis: "high", variant: "body3" }, { children: message }))] }), type));
                    }) })));
            }
            return (_jsxs(Stack, __assign({ sx: __assign({ mt: 3 }, sx), gap: 1, direction: "row", alignItems: "center" }, { children: [ErrorIconElement, _jsx(Text, __assign({ "data-testid": "single-error", category: "error", shade: "dark", emphasis: "high", variant: "body3" }, { children: message }))] })));
        } }));
};
export default ErrorMessage;
